import { useEffect, useState } from 'react';
import { User } from 'lucide-react';
import { useTenantApiToken } from '../../contexts/TenantProfileContext';
import { cachedProspectDocument, loadProspectDocument } from '../../utils/application-document-cache';

export function PersonAvatar({
  documentId,
  onDark,
  size = 'md',
}: {
  documentId: string | null;
  onDark: boolean;
  size?: 'sm' | 'md';
}) {
  const getToken = useTenantApiToken();
  const [loaded, setLoaded] = useState<string | null>(() => (
    documentId ? cachedProspectDocument(documentId)?.objectUrl ?? null : null
  ));

  useEffect(() => {
    if (!documentId) {
      setLoaded(null);
      return undefined;
    }
    const hit = cachedProspectDocument(documentId);
    if (hit) {
      setLoaded(hit.objectUrl);
      return undefined;
    }
    let cancelled = false;
    void loadProspectDocument(getToken, documentId)
      .then((file) => {
        if (!cancelled) setLoaded(file.objectUrl);
      })
      .catch(() => {
        if (!cancelled) setLoaded(null);
      });
    return () => {
      cancelled = true;
    };
  }, [documentId, getToken]);

  const image = documentId ? cachedProspectDocument(documentId)?.objectUrl ?? loaded : null;
  const box = size === 'sm' ? 'h-7 w-7' : 'h-10 w-10';
  if (image) {
    return <img src={image} alt="" className={`${box} shrink-0 rounded-full object-cover`} />;
  }
  return (
    <span className={`flex ${box} shrink-0 items-center justify-center rounded-full ${onDark ? 'bg-white/15 text-white' : 'bg-gray-100 text-gray-400 dark:bg-white/10 dark:text-gray-400'}`}>
      <User size={size === 'sm' ? 14 : 18} />
    </span>
  );
}
